/**
 * @fileoverview TransactionTypeSelector Component
 *
 * Displays buttons for selecting transaction type (Expense, Income, Transfer, Adjustment).
 * Provides the initial transaction type selection interface in the transaction modal.
 *
 * @module components/TransactionForm/TransactionTypeSelector
 */
import styles from './TransactionTypeSelector.module.css';

/**
 * TransactionTypeSelector Component
 *
 * Displays buttons for selecting transaction type (Expense, Income, Transfer, Adjustment).
 * Handles the initial transaction type selection.
 *
 * Props:
 * - onTypeSelect (function): Called when user selects a transaction type
 * - onClose (function): Optional - Called when cancel is clicked (for modal usage)
 */

function TransactionTypeSelector({ onTypeSelect, _onClose }) {

    const handleTypeSelect = (type) => {
        onTypeSelect(type);
    };

    return (
        <div>
            <h4 className={styles.heading}>Select Transaction Type:</h4>
            <div className={styles.buttonContainer}>

                <button
                    onClick={() => handleTypeSelect('Expense')}
                    className={styles.expenseButton}
                >
                    Add Expense
                </button>

                <button
                    onClick={() => handleTypeSelect('Income')}
                    className={styles.incomeButton}
                >
                    Add Income
                </button>

                <button
                    onClick={() => handleTypeSelect('Transfer')}
                    className={styles.transferButton}
                >
                    Transfer
                </button>

                <button
                    onClick={() => handleTypeSelect('Adjustment')}
                    className={styles.adjustmentButton}
                >
                    Adjustment
                </button>

            </div>
        </div>
    );
}

export default TransactionTypeSelector;